import React from 'react';
import {ThemeProvider} from "@mui/material";
import Theme from '../tools/Theme';
import {CacheProvider} from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import {prefixer} from "stylis";

//Note Create RTL Cache
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

const RtlProvider = ({children}) => {
    return (<ThemeProvider theme={Theme}>
            <CacheProvider value={cacheRtl}>
                <div className={'app rtl'}>
                    {children}
                </div>
            </CacheProvider>
        </ThemeProvider>

    );
};

export default RtlProvider;